










































































import Vue from "vue";
import {Component, Ref} from "vue-property-decorator";


@Component({
    components: {}
})
export default class V2FormViewer extends Vue {
    @Ref() date!: HTMLFormElement;
    @Ref() form!: HTMLFormElement;

    mounted () {
        this.date.valueAsDate = new Date();
        document.querySelectorAll('.question input[type=radio]').forEach(el => {
           el.addEventListener('click', this.handleRadio as any);
        });
    }

    handleRadio (e: MouseEvent) {
        if (e.screenX === 0 || e.screenY === 0) return;
        const next = (e.target as Element).getAttribute('data-next') as string;
        const target = document.getElementById(next) as HTMLElement;
        const t = target.querySelector('input[type=text]') as HTMLFormElement;
        if (t) t.focus();
        target.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
    }
}
